import { BUTTONS } from '@/messages/buttons'

/**
 * Interrupt modals
 */
export const INTERRUPT_MODALS: InterruptModalText = {
  // NOTE: these are fallback values and only display
  // if the seller's metadata does NOT contain values for the following metakeys
  // portalPassModalDismissButton, portalPassModalConfirmButton, portalPassModalBody,
  // portalPassBannerBody, portalPassBannerBodyMinimized
  portalPass: {
    body: 'Get unlimited visits with the Meow Wolf Portal Pass. Now 30% off for a limited time only.',
    confirmButton: BUTTONS.buyNow,
    dismissButton: BUTTONS.noThanks,
    bannerBody: 'Upgrade to Annual Pass for $10+ / person and get a year of access to all exhibits',
    bannerBodyMinimized: 'Upgrade to Annual Pass for $10+ / person',
  },
}

/**
 * Expiration modal
 */
export const EXPIRATION_MODAL = {
  header: 'Timer Expired',
  body: 'Sorry, you\'ll have to restart your purchase.',
}

/**
 * Confirmation modals
 */
export const CONFIRMATION_MODALS: ConfirmationModalText = {
  default: {
    confirmButton: BUTTONS.confirmStartOver,
    body: 'Doing that will clear your cart, do you want to proceed?',
  },
  editVisitDate: {
    confirmButton: BUTTONS.confirmStartOver,
    body: 'Changing your visit date will clear your cart, do you want to proceed?',
  },
  startOver: {
    confirmButton: BUTTONS.confirmStartOver,
    body: 'Starting over will clear your cart, do you want to proceed?',
  },
  removeTickets: {
    confirmButton: BUTTONS.confirmRemoveTickets,
    body: 'Are you sure you want to remove these tickets?',
  },
  // NOTE: this may no longer be needed
  login: {
    confirmButton: BUTTONS.confirmLogin,
    body: 'Logging in will clear your cart, do you want to proceed',
  },
  logout: {
    confirmButton: BUTTONS.confirmLogout,
    cancelButton: BUTTONS.cancel,
    bodyLines: [
      'Logging out will remove any items currently in your cart.',
      'Would you like to log out?',
    ],
  },
}
